import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Lamentamos que el artículo no haya sido útil. ¿Nos harías saber qué estuvo mal?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Falta la información que busco',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Hay errores de hecho',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Algunos temas no están claros',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Danos algunos detalles y mejoraremos este artículo.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Enviar'
    }
  }
};